export default __webpack_public_path__ + "static/insfocus_small-3-eab6397a6af87150b49a4d34d099696b.png";